<div class="container incident-view">
  @for (field of formFields; track field) {
    @if (!field.parentControl || visibleForParent(field) ) {
      @if (field.type === 'heading') {
        <h3 class="mt-6 mb-2">{{field.label}}</h3>
        <hr />
      } @else {
        @if (formData[field.group][field.name] !== null) {
          <div class="row mb-4">
            <label for="{{field.name}}" class="lg:col-span-4 md:col-span-5">{{field.label}}</label>
            @if (field.type === 'text' || field.type === 'textarea') {
              <div class="lg:col-span-8 md:col-span-7 multi-line-display">
              {{formData[field.group][field.name]}}</div>
            }
            @if (field.type === 'number') {
              <div class="lg:col-span-8 md:col-span-7">
                {{formData[field.group][field.name] > 0 ? formData[field.group][field.name] : ''}}
              </div>
            }
            @if (field.type === 'yesno') {
              <div class="lg:col-span-8 md:col-span-7">
                {{formData[field.group][field.name] > 0 ? 'Yes' : 'No'}}
              </div>
            }
            @if (field.type === 'datetime' ) {
              <div class="lg:col-span-8 md:col-span-7">
                {{formData[field.group][field.name] | date:'MM/dd/yyyy h:mm aa'}}
              </div>
            }
            @if (field.type === 'date' ) {
              <div class="lg:col-span-8 md:col-span-7">
                {{formData[field.group][field.name] | date: 'MM/dd/yyyy'}}
              </div>
            }
            @if (field.type === 'dob') {
              <div class="lg:col-span-8 md:col-span-7">
                {{formData[field.group][field.name] | date: 'MM/dd/yyyy'}} (age {{formData[field.group][field.name] | age}})
              </div>
            }
            @if (field.type === 'dropdown') {
              <div class="lg:col-span-8 md:col-span-7">
                {{getOptionForField(field)}}
              </div>
            }
            @if (field.type === 'checkbox') {
              <div class="lg:col-span-8 md:col-span-7">
                {{formData[field.group][field.name] ? 'Yes' : 'No'}}
              </div>
            }
          </div>
        }
      }
    }
  }
</div>